import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Projects from './Project/ProjectsPage';
import Resume from './Resume/Resume';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const App: React.FC = () => {
    return (
        <div id="page">
            <div className="bodySection" id="Projects">
                <Projects />
            </div>
            <div className="bodySection" id="Resume">
                <Resume />
            </div>
        </div>
    );
};

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
